export type { ShimmerProps } from './shimmer';
export { default } from './shimmer';
